import React from 'react'
import { AffinityProvider, GlobalStyle } from '@allied-solutions/affinity'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

import { theme } from './src/theme.js'
import { StateProvider } from './src/store'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
})

export default ({ element }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <AffinityProvider theme={theme}>
        <GlobalStyle />
        <StateProvider>{element}</StateProvider>
      </AffinityProvider>
    </QueryClientProvider>
  )
}
